import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, interval, Subscription } from 'rxjs';
import { CONCURRENCY_PROVIDER_SERVICE, IConcurrencyProviderService } from '../../../interfaces';

@Component({
  selector: 'app-concurrency-label',
  templateUrl: './concurrency-label.component.html',
  styleUrls: ['./concurrency-label.component.css']
})
export class ConcurrencyLabelComponent implements OnDestroy, OnInit {

  @Input() entityIsSupported = true;

  _isValid = new BehaviorSubject(true);
  isValid$ = this._isValid.asObservable();
  secondsAgo = 0;

  private _subscriptions: Subscription[] = [];

  constructor(@Inject(CONCURRENCY_PROVIDER_SERVICE) public service: IConcurrencyProviderService) { }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._subscriptions.push(...[
      interval(1000).subscribe(() => {
        this.secondsAgo++;
        if(this.secondsAgo === 10 && this.entityIsSupported) {
          this.service.validStamp$.subscribe((valid: boolean) => {
            this._isValid.next(valid);
            this.secondsAgo = 0;
          })
        }
      })
    ]);
  }

}
